import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    DELETE_ITEM,
    DELETE_ITEM_FAILURE,
    DELETE_ITEM_SUCCESS,
    FETCH_COUNTRIES_ITEMS,
    FETCH_COUNTRIES_ITEMS_FAILURE,
    FETCH_COUNTRIES_ITEMS_SUCCESS,
    FETCH_ITEM,
    FETCH_ITEM_FAILURE,
    FETCH_ITEM_SUCCESS,
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
    FETCH_PRODUCTS,
    FETCH_PRODUCTS_FAILURE,
    FETCH_PRODUCTS_SUCCESS,
    FETCH_ROOF_TYPES,
    FETCH_ROOF_TYPES_FAILURE,
    FETCH_ROOF_TYPES_SUCCESS,
    FETCH_TEMPLATES,
    FETCH_TEMPLATES_FAILURE,
    FETCH_TEMPLATES_SUCCESS,
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_FORM,
    INITIALIZE_SUCCESS,
    OPEN_MODAL_PRODUCT,
    RESET_FORM,
    SAVE_ITEM,
    SAVE_ITEM_FAILURE,
    SAVE_ITEM_SUCCESS,
    SET_IS_NEW_RECORD,
    UPDATE_ITEMS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: { errors: null, isSaving: false },
    countries: { data: [], errors: null, isFetching: false },
    deleteItem: { errors: null, isDeleting: false },
    fetchItem: { data: {}, errors: null, isFetching: false },
    fetchItems: {
        data: { data: [], pagination: null },
        errors: null,
        isFetching: false,
    },
    fetchProducts: { data: [], errors: null, isFetching: false },
    fetchTemplates: { data: [], errors: null, isFetching: false },
    fetchRoofTypes: { data: [], errors: null, isFetching: false },
    initialValues: {
        country: '',
        custom_offer_template: '',
        id: null,
        name: null,
        products: [{ item: '' }],
        type_application: null,
    },
    isInitializing: false,
    isNewRecord: true,
    isOpenModalProduct: false,
    saveItem: { errors: null, isSaving: false },
};

const slice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isSaving: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isSaving: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                isSaving: false,
            };
        },
        [DELETE_ITEM]: (state) => {
            state.deleteItem = {
                ...state.deleteItem,
                errors: [],
                isDeleting: true,
            };
        },
        [DELETE_ITEM_FAILURE]: (state, action) => {
            state.deleteItem = {
                ...state.deleteItem,
                errors: action.payload,
                isDeleting: false,
            };
        },
        [DELETE_ITEM_SUCCESS]: (state) => {
            state.deleteItem = {
                ...state.deleteItem,
                isDeleting: false,
            };
        },
        [FETCH_COUNTRIES_ITEMS]: (state) => {
            state.countries = {
                ...state.countries,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_COUNTRIES_ITEMS_FAILURE]: (state, action) => {
            state.countries = {
                ...state.countries,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_COUNTRIES_ITEMS_SUCCESS]: (state, action) => {
            state.countries = {
                ...state.countries,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRODUCTS]: (state) => {
            state.fetchProducts = {
                ...state.fetchProducts,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PRODUCTS_FAILURE]: (state, action) => {
            state.fetchProducts = {
                ...state.fetchProducts,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRODUCTS_SUCCESS]: (state, action) => {
            state.fetchProducts = {
                ...state.fetchProducts,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ROOF_TYPES]: (state) => {
            state.fetchRoofTypes = {
                ...state.fetchRoofTypes,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ROOF_TYPES_FAILURE]: (state, action) => {
            state.fetchRoofTypes = {
                ...state.fetchRoofTypes,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ROOF_TYPES_SUCCESS]: (state, action) => {
            state.fetchRoofTypes = {
                ...state.fetchRoofTypes,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_TEMPLATES]: (state) => {
            state.fetchTemplates = {
                ...state.fetchTemplates,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_TEMPLATES_FAILURE]: (state, action) => {
            state.fetchTemplates = {
                ...state.fetchTemplates,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_TEMPLATES_SUCCESS]: (state, action) => {
            state.fetchTemplates = {
                ...state.fetchTemplates,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEMS]: (state) => {
            state.fetchItems = {
                ...state.fetchItems,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEMS_FAILURE]: (state, action) => {
            state.fetchItems = {
                ...state.fetchItems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEMS_SUCCESS]: (state, action) => {
            state.fetchItems = {
                ...state.fetchItems,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM]: (state) => {
            state.fetchItem = {
                ...state.fetchItem,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEM_FAILURE]: (state, action) => {
            state.fetchItem = {
                ...state.fetchItem,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM_SUCCESS]: (state, action) => {
            state.fetchItem = {
                ...state.fetchItem,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE]: (state) => {
            state.isInitializing = true;
        },
        [INITIALIZE_FAILURE]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_SUCCESS]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [OPEN_MODAL_PRODUCT]: (state, action) => {
            state.isOpenModalProduct = action.payload;
        },
        [RESET_FORM]: (state) => {
            const { fetchProducts, fetchTemplates, initialValues } =
                INITIAL_STATE;

            return {
                ...state,
                fetchProducts,
                fetchTemplates,
                initialValues,
            };
        },
        [SAVE_ITEM]: (state) => {
            state.saveItem = { ...state.saveItem, errors: [], isSaving: true };
        },
        [SAVE_ITEM_FAILURE]: (state, action) => {
            state.saveItem = {
                ...state.saveItem,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_ITEM_SUCCESS]: (state) => {
            state.saveItem = {
                ...state.saveItem,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.fetchItems.data.data = action.payload;
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;
